import React from 'react';

/**
 * Återanvändbar Card-komponent för informationsrutor
 * Stödjer två varianter: 'large' och 'small'
 */
const Card = ({
  variant = 'large',
  icon: IconComponent,
  iconBgColor = 'bg-brand-primary',
  iconTextColor = 'text-inverse',
  title,
  description,
  className = '',
  ...props
}) => {
  const baseClasses = "bg-white shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300 hover:cursor-pointer";
  
  if (variant === 'small') {
    return (
      <div className={`${baseClasses} p-4 rounded-lg flex items-center space-x-4 ${className}`} {...props}>
        <div className="flex-shrink-0">
          <div className={`w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center`}>
            {IconComponent && <IconComponent className={`w-6 h-6 ${iconTextColor}`} />}
          </div>
        </div>
        <div className="flex-grow min-w-0">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          <p className="text-gray-900 text-sm">{description}</p>
        </div>
      </div>
    );
  }

  // Large variant (default)
  return (
    <div className={`${baseClasses} p-8 rounded-2xl ${className}`} {...props}>
      <div className={`w-16 h-16 ${iconBgColor} rounded-2xl flex items-center justify-center mb-6`}>
        {IconComponent && <IconComponent className={`w-8 h-8 ${iconTextColor}`} />}
      </div>
      <h3 className="text-heading-h3 font-bold text-primary dark:text-gray-900 mb-custom-4">{title}</h3>
      <p className="text-secondary dark:text-gray-900 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default Card;